<template>
  <div>
    <el-dialog title="动态资讯"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               @close="emitClose">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="100px">
        <el-form-item label="动态标题："
                      prop="title">
          <el-input v-model="dataForm.title"></el-input>
        </el-form-item>
        <el-form-item label="">
          <UEeditor :setDataStr="dataForm.content"
                    @change="initDtaForm" />
        </el-form-item>
        <el-form-item label="发布状态：">
          <el-switch v-model="dataForm.status"
                     :active-value="1"
                     :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="emitClose">取 消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {} from '@/api/article'
import {} from '@/api/news'
import { getStorage } from '@/utils/helper'
import UEeditor from '@/components/UEeditor'
import { manageUrl } from '@/utils/helper.js'

export default {
  components: {
    UEeditor,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dataForm: {},
      dialogFormVisible: this.isVisible,
      rules: {
        title: [{ required: true, message: '请输入标题名称', trigger: 'blur' }],
      },
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
      if (val) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    initDtaForm(e) {
      this.dataForm.content = e
    },
    emitClose() {
      this.dataForm = {}
      this.$emit('close')
    },
    fetchDetail() {
      let str = manageUrl()
      // @@@@@@@
      this.$axios({
        url: `${str}/api/v1/seniorWork/news`,
        method: 'get', //可以省略 不写默认是get
        params: {
          id: this.id,
        },
        headers: {
          // 设置请求头
          Authorization: localStorage.getItem('admin_token'),
        },
      }).then((response) => {
        let res = response.data
        if (res.code == 0) {
          this.dataForm = res.data
        }
      })
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm)
          delete params.creator
          delete params._delete
          delete params.sort
          delete params.update_time
          delete params.create_time
          let str = manageUrl()
          //  @@@@@@@
          this.$axios({
            url: `${str}/api/v1/seniorWork/news`,
            method: 'put', //可以省略 不写默认是get
            data: params,
            headers: {
              // 设置请求头
              Authorization: localStorage.getItem('admin_token'),
            },
          }).then((response) => {
            let res = response.data
            if (res.code == 0) {
              this.$message.success('提交成功')
              this.$emit('submit')
              this.emitClose()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;
  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
</style>